<template>
    <span class="text-center bg-neutral no-info" :class="{'with-text': text}">{{ text || '-'}}</span>
</template>

<script>

export default {
    name: "NoInfo",
    props: ['text']
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";
    .no-info {
        display: inline-block;
        font-size: 18px;
        line-height: 26px;
        min-width: 98px;
        border-radius: 4px;

        @include responsive-below($md){
            min-width: 105px;
        }

        &.with-text {
            font-size: 11px;
            color: #959595;
            padding: 6px 12px;
        }
    }
</style>
